import * as React from "react"
import {Form, Icon, InputOnChangeData} from "semantic-ui-react"
import {isValidEmailAddress} from "../email"
import {MapState} from "./BookingDetails"

interface InnerState {
  value: string
}

export interface PaymentInviteOuterState {
  toEmail: string | null
  editing: boolean
}

interface Props {
  state: PaymentInviteOuterState
  mapState: MapState<PaymentInviteOuterState> | null
  disabled: boolean
}

export class PaymentInviteField extends React.Component<Props, InnerState> {
  constructor(props: Props) {
    super(props)
    this.state = {value: props.state.toEmail || ""}
  }

  render() {
    const {value} = this.state
    const {
      state: {toEmail, editing},
      disabled,
      mapState,
    } = this.props
    if (editing && mapState) {
      const valueEntered = value.length > 0
      const valueValid = valueEntered && isValidEmailAddress(value)
      return (
        <>
          <Form.Field error={valueEntered && !valueValid}>
            <label>Payment Invitation</label>
            <Form.Group>
              <Form.Input
                type="email"
                placeholder="Email"
                error={valueEntered && !valueValid}
                value={value}
                onChange={(e: any, field: InputOnChangeData) => {
                  this.setState({value: field.value})
                }}
              />
              <Form.Button
                children="Save"
                onClick={() => {
                  mapState((state) => ({
                    toEmail: value,
                    editing: false,
                  }))
                  this.setState({value: ""})
                }}
                disabled={!valueValid}
              />
              <Form.Button
                children="Reset"
                onClick={() => {
                  mapState((state) => ({
                    ...state,
                    editing: false,
                  }))
                  this.setState({value: ""})
                }}
              />
            </Form.Group>
          </Form.Field>
        </>
      )
    } else if (toEmail !== null) {
      return (
        <>
          <Form.Field>
            <label>Payment Invitation</label>
            {mapState && (
              <>
                <Icon
                  link={!disabled}
                  onClick={() => {
                    if (!disabled) {
                      mapState((state) => ({
                        toEmail: null,
                        editing: false,
                      }))
                    }
                  }}
                  name="close"
                  color="grey"
                  disabled={disabled}
                />
                <span style={{display: "inline-block", width: 10}} />
              </>
            )}
            <span>{toEmail}</span>
          </Form.Field>
        </>
      )
    } else if (mapState) {
      return (
        <>
          <Form.Button
            content="Invite someone to pay"
            icon="chevron right"
            labelPosition="right"
            disabled={disabled}
            onClick={() => {
              this.setState({value: ""})
              mapState((state) => ({
                ...state,
                editing: true,
              }))
            }}
          />
        </>
      )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PaymentInviteField.tsx